module.exports = __webpack_public_path__ + "static/media/AvaxCats.521dda18.jpg";